// extracted by mini-css-extract-plugin
export default {"label__text":"styles_label__text__bxGbx","value__text":"styles_value__text__RnY75"};